
import {
  Order,
  PartialNcsConfig,
  defaultKwicConfig,
  defaultFilterConfig,
  defaultOrder,
  defaultQueryConfig,
} from "ncs"

const documentOrders: Order[] = [
  { name: "documents.level", criteria: [{ field: "documents.level", asc: true }] },
  { name: "documents.gender", criteria: [{ field: "documents.gender", asc: true }] },
  { name: "documents.l1", criteria: [{ field: "documents.l1", asc: true }] },
  { name: "documents.english_status", criteria: [{ field: "documents.english_status", asc: true }] },
  { name: "documents.preparation_course", criteria: [{ field: "documents.preparation_course", asc: true }] },
  { name: "documents.text_formality", criteria: [{ field: "documents.text_formality", asc: true }] },
  { name: "documents.text_type", criteria: [{ field: "documents.text_type", asc: true }] },
  { name: "documents.illocutionary_act", criteria: [{ field: "documents.illocutionary_act", asc: true }] },
  { name: "documents.text_topic", criteria: [{ field: "documents.text_topic", asc: true }] },
  { name: "documents.candidate_number", criteria: [{ field: "documents.candidate_number", asc: true }] },
]

export const ncsConfig: PartialNcsConfig = {
  elements: {
    types: ["units", "documents"],
  },
  filters: [
    ...defaultFilterConfig,
    { field: "documents.level" },
    { field: "documents.gender" },
    { field: "documents.l1" },
    { field: "documents.english_status" },
    { field: "documents.preparation_course" },
    { field: "documents.text_formality" },
    { field: "documents.text_type" },
    { field: "documents.illocutionary_act" },
    { field: "documents.text_topic" },
    { field: "documents.candidate_number", operator: 'eq_any' },
    { field: "documents.several_texts" },
  ],
  result: {
    defaultType: "kwic",
    error: {
      contactLink: "./contacto",
      contactEmail: "soporte@nlpgo.com"
    },
    types: ["frequency", "full_frequency", "kwic", "documents"]
  },
  queries: {
    kwic: {
      ...defaultKwicConfig,
      order: {
        orders: [...defaultOrder(5), ...documentOrders],
      }
    },
    documents: {
      ...defaultQueryConfig,
      endpoint: 'documents',
      elements: {
        ...defaultQueryConfig.elements,
        distances: false,
        types: ['documents'],
        defaultType: 'documents'
      },
      order: {
        orders: documentOrders,
        default: ['documents.level', 'documents.candidate_number']
      },
      pagination: true
    }
  }
}
